import {ILoanRequestRuleResponse} from '../../../../../../../services/hookService/getLoanRequestRule/types';
import {PersonPrefix} from '../MultiPersonForm/MultiPersonValidation';

export const PersonSectionConfigs: Record<
  PersonPrefix,
  {
    buttonTitle: string;
    headerTitle: string;
    description: string;
  }
> = {
  self: {
    buttonTitle: 'ثبت چک',
    headerTitle: 'اطلاعات چک',
    description: 'اطلاعات چک شخص متقاضی را وارد کنید',
  },

  'Guarantor-0': {
    buttonTitle: ' چک ضامن اول',
    headerTitle: 'اطلاعات ضامن اول',
    description: 'اطلاعات چک ضامن اول را وارد کنید',
  },

  'Guarantor-1': {
    buttonTitle: ' چک ضامن دوم',
    headerTitle: 'اطلاعات ضامن دوم',
    description: 'اطلاعات چک ضامن دوم را وارد کنید',
  },
};

export const getSelfCheckCount = (rules: ILoanRequestRuleResponse): number => {
  let count = 0;

  if (rules.owner_first_cheque_price > 0) count++;
  if (rules.owner_second_cheque_price > 0) count++;
  if (rules.owner_third_cheque_price > 0) count++;

  return count;
};

export const getSelfButtonTitle = (rules: ILoanRequestRuleResponse): string => {
  const count = getSelfCheckCount(rules);

  return count > 1 ? 'ثبت چک‌ ها' : 'ثبت چک';
};

export const getGuarantorCheckCount = (
  rules: ILoanRequestRuleResponse,
): number => {
  let count = 0;

  if (rules.first_guarantor_cheque_price > 0) count++;
  if (rules.second_guarantor_cheque_price > 0) count++;

  return count;
};
